import { useContext, useEffect } from 'react'

import {
  DocumentTitleContext,
  formatDocumentTitle
} from 'src/context/DocumentTitle'

export const useDocumentTitle = (title?: string | null) => {
  const context = useContext(DocumentTitleContext)

  useEffect(() => {
    if (context) {
      context.setOverride(title ?? undefined)

      return () => context.setOverride(undefined)
    }

    document.title = formatDocumentTitle(title)
  }, [context, title])
}

export const useSectionTitle = (title?: string | null) => {
  const context = useContext(DocumentTitleContext)

  useEffect(() => {
    context?.setSection(title ?? undefined)

    return () => context?.setSection(undefined)
  }, [context, title])
}

export const useAppTitle = (title?: string | null) => {
  const context = useContext(DocumentTitleContext)

  useEffect(() => {
    context?.setApp(title ?? undefined)

    return () => context?.setApp(undefined)
  }, [context, title])
}
